import React, { useEffect, useCallback, createContext, useState } from 'react';
import { LOGIN } from 'store/actions';
import { useDispatch } from 'react-redux';

export const UserContext = createContext();

const UserProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [isUserLoaded, setIsUserLoaded] = useState(false);

  const loadUser = useCallback(() => {
    // Try unified D1 auth first (d1easytrans_auth)
    let raw = localStorage.getItem('d1easytrans_auth');
    if (raw) {
      try {
        const data = JSON.parse(raw);
        if (data.token) {
          dispatch({ type: LOGIN, payload: data });
          setIsUserLoaded(true);
          return;
        }
      } catch (_) {}
    }
    // Fallback to legacy user storage
    raw = localStorage.getItem('user');
    if (raw) {
      try {
        const data = JSON.parse(raw);
        dispatch({ type: LOGIN, payload: data });
      } catch (_) {}
    }
    setIsUserLoaded(true);
  }, [dispatch]);

  useEffect(() => {
    loadUser();
  }, [loadUser]);

  return <UserContext.Provider value={{ loadUser, isUserLoaded }}> {children} </UserContext.Provider>;
};

export default UserProvider;
